var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_2_2348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12305 12.8771L9.54675 16.8177C9.54675 16.8177 9.72475 17.1864 9.91535 17.1864C10.1059 17.1864 12.9408 14.2372 12.9408 14.2372L16.0933 8.14819L8.17385 11.8599L8.12305 12.8771Z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0105 13.8878L9.73721 16.7924C9.73721 16.7924 9.62281 17.6824 10.5126 16.7924C11.4024 15.9024 12.2541 15.2161 12.2541 15.2161",
    fill: "#A9C6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14822 13.0178L5.21962 12.0636C5.21962 12.0636 4.86962 11.9216 4.98232 11.5996C5.00552 11.5332 5.05232 11.4767 5.19232 11.3796C5.84122 10.9273 17.2029 6.84359 17.2029 6.84359C17.2029 6.84359 17.5237 6.73549 17.7129 6.80739C17.7597 6.82188 17.8018 6.84854 17.835 6.88465C17.8681 6.92076 17.891 6.96501 17.9014 7.01289C17.9219 7.09746 17.9304 7.18446 17.9268 7.27139C17.9259 7.34659 17.9168 7.41629 17.9099 7.52559C17.8407 8.64209 15.7699 16.9749 15.7699 16.9749C15.7699 16.9749 15.646 17.4625 15.2021 17.4792C15.093 17.4827 14.9844 17.4642 14.8826 17.4249C14.7808 17.3855 14.6879 17.326 14.6096 17.25C13.7385 16.5007 10.7277 14.4773 10.0624 14.0323C10.0474 14.0221 10.0348 14.0087 10.0254 13.9932C10.0159 13.9777 10.01 13.9603 10.0078 13.9423C9.99852 13.8954 10.0495 13.8373 10.0495 13.8373C10.0495 13.8373 15.2921 9.17729 15.4316 8.68809C15.4424 8.65019 15.4016 8.63149 15.3468 8.64809C14.9986 8.77619 8.96242 12.5881 8.29622 13.0088C8.24827 13.0233 8.19758 13.0264 8.14822 13.0178Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2348",
    x1: 12,
    y1: 24,
    x2: 12,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/Telegram_logo.0f5cbe65737bdd96aab266181b568d38.svg";
export { ForwardRef as ReactComponent };